export default {"src":"/_next/static/media/cart-icon-dark-nonempty.63d9248c.svg","height":22,"width":25};